var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnInit, AfterViewInit, ElementRef, Renderer2, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { EngineState } from 'src/app/engine/state/engine.state';
import { Observable, Subject } from 'rxjs';
import { FormControl } from '@angular/forms';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
import { filter, takeUntil, distinctUntilChanged } from 'rxjs/operators';
import * as _ from 'lodash';
import { EngineNodesState } from 'src/app/engine/state/nodes/engine.nodes.state';
import { EngineService, EngineEventsEnum } from 'src/app/engine/engine.service';
var NavigationContextComponent = /** @class */ (function () {
    function NavigationContextComponent(store, renderer, changeDetector, engineEventsService) {
        this.store = store;
        this.renderer = renderer;
        this.changeDetector = changeDetector;
        this.engineEventsService = engineEventsService;
        this._selectedColumnGroup = 'chapters';
        this.loadingLabel = '';
        this.interactive = false;
        this.searchHeight = 0;
        this.searchControl = new FormControl('');
        this.searchResults = [];
        this.query = '';
        this.copies = [];
        this.ngUnsubscribe = new Subject();
    }
    Object.defineProperty(NavigationContextComponent.prototype, "selectedColumnGroup", {
        get: function () {
            return this._selectedColumnGroup;
        },
        set: function (value) {
            this._selectedColumnGroup = value;
        },
        enumerable: true,
        configurable: true
    });
    NavigationContextComponent.prototype.ngOnInit = function () {
        var _this = this;
        var _currentChapter = this.store.selectSnapshot(StoryChaptersState.getSelectedChapter);
        if (_currentChapter && _currentChapter.readyState.model) {
            this.interactive = true;
        }
        this.searchControl.valueChanges
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (query) {
            _this.query = query;
            _this.searchResults = _this.search(query);
            _this.getSearchHeight()
                .pipe(takeUntil(_this.ngUnsubscribe))
                .subscribe(function (height) {
                _this.searchHeight = height;
                _this.changeDetector.markForCheck();
            });
        });
        this.engineEventsService.getEvent(EngineEventsEnum.AssetsLoadProgress)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (result) {
            var chaptersLoaded = _this.store.selectSnapshot(StoryChaptersState.getChaptersLoaded);
            var loadingLabel = '';
            if (chaptersLoaded.count > 1) {
                loadingLabel = "Loading Chapter " + (chaptersLoaded.modelChapters.length + 1) + " of " + chaptersLoaded.count + ": ";
            }
            loadingLabel += Math.round(result.receivedAssets / result.requestedAssets * 100) + "%";
            _this.loadingLabel = loadingLabel;
            _this.changeDetector.markForCheck();
        });
        this.currentChapter$.pipe(filter(function (chapter) { return chapter != null; }), takeUntil(this.ngUnsubscribe)).subscribe(function (chapter) {
            _this.interactive = chapter.readyState.model;
        });
        // When nodes are checked, flip to the the anatomy tree so
        // that the user can see what is checked
        this.store.select(EngineNodesState.getCheckedNodes)
            .pipe(filter(function (nodes) { return nodes.length > 0; }), distinctUntilChanged(), takeUntil(this.ngUnsubscribe))
            .subscribe(function (nodes) {
            _this.selectedColumnGroup = 'anatomy';
            _this.changeDetector.markForCheck();
        });
    };
    NavigationContextComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        // Window has resized, let the 3D canvas know
        this.renderer.listen('window', 'resize', function (event) {
            _this.getSearchHeight()
                .pipe(takeUntil(_this.ngUnsubscribe))
                .subscribe(function (height) {
                _this.searchHeight = height;
                _this.changeDetector.markForCheck();
            });
        });
    };
    NavigationContextComponent.prototype.ngOnDestroy = function () {
        this.changeDetector.detach();
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    NavigationContextComponent.prototype.handleKeyup = function (event) {
        if (event.key === 'Escape') {
            this.clearQuery();
            this.searchInput.nativeElement.blur();
        }
    };
    NavigationContextComponent.prototype.getSearchHeight = function () {
        var _this = this;
        return new Observable(function (observer) {
            var offsetHeight = _.get(_this.columnGroupBody, 'nativeElement.parentElement.offsetHeight');
            if (offsetHeight != null) {
                observer.next(offsetHeight);
                observer.complete();
            }
        });
    };
    NavigationContextComponent.prototype.clearQuery = function () {
        this.searchControl.setValue('');
    };
    NavigationContextComponent.prototype.search = function (query) {
        var viewGraph = this.store.selectSnapshot(EngineState.getViewGraph);
        query = query.toLowerCase();
        var results = Object.values(viewGraph.nodes)
            .filter(function (node) { return node.label.toLowerCase().indexOf(query) >= 0; })
            .sort(function (a, b) {
            return a.label.localeCompare(b.label);
        })
            .sort(function (a, b) {
            return Math.sign(a.getDepth() - b.getDepth());
        });
        return results;
    };
    NavigationContextComponent.prototype.trackTreeNode = function (index, node) {
        return node.id;
    };
    __decorate([
        Select(EngineState.getViewGraph),
        __metadata("design:type", Observable)
    ], NavigationContextComponent.prototype, "viewGraph$", void 0);
    __decorate([
        Select(StoryChaptersState.getSelectedChapter),
        __metadata("design:type", Observable)
    ], NavigationContextComponent.prototype, "currentChapter$", void 0);
    __decorate([
        Select(StoryChaptersState.getChaptersLoaded),
        __metadata("design:type", Observable)
    ], NavigationContextComponent.prototype, "chaptersLoaded$", void 0);
    __decorate([
        Select(StoryChaptersState.getAllChaptersReady),
        __metadata("design:type", Observable)
    ], NavigationContextComponent.prototype, "allChaptersReady$", void 0);
    return NavigationContextComponent;
}());
export { NavigationContextComponent };
